import React from "react";
import {
  CircularProgress,
  Grid,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

const Spinner = (props) => {
  const { show, fullscreen } = props;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      {show && (
        <Paper
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            width: "100%",
            position: "fixed",
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            zIndex: 10000,
          }}
        >
          <Grid
            container
            direction="column"
            sx={{
              gap: "16px",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <CircularProgress
              color="primary"
              size={isMobile ? "2rem" : "4rem"}
              aria-label="Loading…"
            />
            <Typography
              variant="body1"
              sx={{ color: theme.branding.gray[500] }}
            >
              Loading...
            </Typography>
          </Grid>

          {/* Spotlight footer */}
          <Grid
            container
            sx={{
              width: "100%",
              justifyContent: "center",
              padding: isMobile ? "24px 16px" : "24px 32px",
              position: "fixed",
              bottom: 0,
            }}
          >
            <Typography
              variant="body2"
              sx={{ color: theme.branding.gray[500] }}
            >
              Sponsored by{" "}
              <span
                style={{ color: theme.branding.cyan[300], fontWeight: 600 }}
              >
                SpotlightNews
              </span>
            </Typography>
          </Grid>
        </Paper>
      )}
    </>
  );
};

export default Spinner;
